import React from 'react';
import { Label } from 'reactstrap';
import { useFlightBooking } from '../context/FlightBookingContext';

function FlightStepNavigation({ flightOptionRefs }) {
  const { activeOption, optionStatus, goNext, goPrev } = useFlightBooking();

  const handleNext = async () => {
    const isValid = await flightOptionRefs[activeOption]?.current?.validate();
    if (isValid) goNext();
  };

  const handlePrev = () => {
    goPrev();
  };

  return (
    <div className="d-flex align-items-center gap-3">
      <button
        type="button"
        onClick={handlePrev}
        disabled={activeOption === 0}
        className="ba-navigate-btn"
      >
        Previous
      </button>
      {[0, 1, 2].map(i => (
        <div
          className={` ${activeOption === i ? 'ba-option-wrapper-active' : 'ba-option-wrapper'}`}
          key={i}
        >
          <Label className="d-flex align-items-center justify-content-center mb-0 gap-1">
            <input type="checkbox" checked={optionStatus[i]} readOnly />
            Option {i + 1}
          </Label>
        </div>
      ))}
      <button
        type="button"
        onClick={handleNext}
        className="ba-navigate-btn"
        disabled={activeOption === 2}
      >
        Next
      </button>
    </div>
  );
}

export default FlightStepNavigation;
